// extracted by mini-css-extract-plugin
export default {"Navbar":"NavbarStyle_Navbar__JYGod","Hidden":"NavbarStyle_Hidden__Qgjk8"};